import http from 'hub-http/clients/apiClient';
import PortalIdParser from 'PortalIdParser';
export const OWNERS_REMOTE_ID_API_V2 = '/owners/v2/owners/remoteId';
export function getOwnerIdFromUserId(userId) {
  const portalId = PortalIdParser.get();
  const url = `${OWNERS_REMOTE_ID_API_V2}/${userId}?portalId=${portalId}`;
  return http.get(url);
}